import { PipeTransform } from '@angular/core';
var RemoveLocationNamePipe = /** @class */ (function () {
    function RemoveLocationNamePipe() {
    }
    RemoveLocationNamePipe.prototype.transform = function (formattedAddress, locationName) {
        return (formattedAddress || '').replace(locationName + " - ", '');
    };
    return RemoveLocationNamePipe;
}());
export { RemoveLocationNamePipe };
